// var $ = require('jquery')

// This is your plugin object. It can be exported to be used anywhere.
const MyI18NLoader = {

  name: 'I18N',
  install (Vue, options) {
    // We call Vue.mixin() here to inject functionality into all components.
    // var cmp = this
    Vue.i18n.add('de', this.data.translationsDe)
    Vue.i18n.add('en', this.data.translationsEn)
    Vue.i18n.set('de')
    /*
    if (Vue.config.I18N_LOAD) {
      console.log('Load i18n ' + Vue.config.I18N_APP_NAME)
      $.getJSON(Vue.config.host + '/I18N/export/' + Vue.config.I18N_APP_NAME, function (data) {
        Vue.i18n.add('de', data.localeDE)
        Vue.i18n.add('en', data.localeEN)
        Vue.i18n.set('de')
        if (cmp.starter) {
          cmp.starter()
        }
      })
    }
    */

    // set the start locale to use
    Vue.mixin({
      // Anything added to a mixin will be injected into all components.
      // In this case, the mounted() method runs when the component is added to the DOM.
      mounted () {
      }
    })
  },
  data: {
    'translationsDe': {
      'logInTitle': 'Anmelden',
      'loginUserNameLabel': 'Username',
      'loginPasswordLabel': 'Passwort',
      'loginSubmit': 'Login',
      'Login.versionTitle': 'Version',
      'Login.version': '1.0',
      'titleUploadWrongFileTyp': 'Falscher Dateityp',
      'textUploadWrongFileTyp': 'Nur PDF Dateien werden für Drag&Drop unterstützt',
      'BUTT_NAV_BACK': 'Zurück',
      'Title_Search': 'Finden.',
      'BTN_PRINT': 'Drucken',
      'BTN_DOWNLOAD': 'Download',
      'BTN_SAVE': 'Speichern',
      'KEY_FILE_CREATED': 'Dokument erstellt',
      'KEY_FILE_UPLOADED': 'Dokument hochgeladen',
      'MAIL_SALUT': 'Hallo',
      'MAIL_REGARDS': 'Viele Grüße',
      'MAIL_SUBJECT': 'Dokumente',
      'MAIL_FROM_NAME': 'SurfAndScan Nutzer',
      'KEY_MAIL_SEND': 'Per E-Mail versendet',
      'RM_TITLE_MAIL': 'Mail Versenden',
      'RM_MESSAGE_NOT_ACTIVATED': 'Mail Versand ist nicht aktiviert.',
      'RM_MAIL_SEND_FAILED': 'Mail Versand ist fehlgeschlagen.',
      'RM_MAIL_SEND_SUCCESS': 'Mail Versand erfolgreich.',
      'RM_TITLE_UPDATE_STATUS': 'Dokument Status setzen',
      'RM_SUCCESS': 'Erfolgreich',
      'RM_FAILED': 'Fehlgeschlagen',
      'RM_TITLE_FILE_DELETE': 'Dokument löschen',
      'RM_TITLE_UPDATE_CATEGORY': 'Dokument Kategorie setzen'
    },
    'translationsEn': {
      'BUTT_NAV_BACK': 'Back',
      'Title_Search': 'Finden.'
    }
  }
}
export default MyI18NLoader



// WEBPACK FOOTER //
// ./src/components/I18N/i18n.js